export default class Storage {
  handlers = [];

  subscribe = (handler) => {
    this.handlers.push(handler);
  };

  setState = (state) => {
    this.state = state;
    this.handlers.forEach((handler) => handler.handle(state));
  };

  getState = () => this.state;
}
